export default class Question {
  constructor (id, stateObj, menu, cartElementBuilder) {
    this.stateObj = stateObj
    this._questionDefinition = menu.questions[id]
    this._menu = menu
    this.cartElementBuilder = cartElementBuilder
  }
  get id () { return this._questionDefinition.id }

  get type () { return this._questionDefinition.type }
  get title () { return this._questionDefinition.title }
  get require () { return this._questionDefinition.require } // TODO: 這個之後可以刪掉
  // defaultValue === undefined 代表沒有給初始值
  get defaultValue () { return this._questionDefinition.defaultValue }
  get alwaysDisplay () { return this._questionDefinition.alwaysDisplay }
  get value () {
    return this.stateObj.values[this.id]
      ? this.stateObj.values[this.id].value || this.defaultValue
      : this.defaultValue
  }
  get instanceId () { return this.stateObj.values[this.id] ? this.stateObj.values[this.id].instanceId : 'unknow' }
  get totalPrice () { return 0 }
  get selectedOptions () { return [] }
  get selectedOptionIds () { return [] }
  get hasValue () { return !!this.value }
  get valueString () { return this.hasValue ? this.value : '' }
  get isValueDefault () {
    return (!this.defaultValue && !this.stateObj.values[this.id]) ||
      (!!this.defaultValue && this.defaultValue !== this.value)
  }
  get isValid () { return this.require ? this.hasValue : true }
  get inValidQuestions () { return this.isValid ? [] : [this.title] }
  get errorMessage () { return this.title + '尚未填寫' }
  optionAmount () { return this.value ? 1 : 0 }
}
